// Game configuration constants
export const MAX_TRIES = 15;
// Daily mode uses the standard MAX_TRIES per round
export const MAX_SKIPS = 3;
export const MAX_STREAK = 2000; // Used in DraggableMaskedImage for maskScale max
export const ZOOM_MULTIPLIER = 1.15; // Used in Image component for mask size increase
export const SUCCESS_GUESS_COUNT = 100; // Used when showing success state
export const DAILY_ROUNDS = 3; // Daily mode consists of 3 rounds

// Image dimensions
export const DEFAULT_IMAGE_WIDTH = 820;
export const DEFAULT_IMAGE_HEIGHT = 505;
export const DEFAULT_MASK_WIDTH = 75;
export const DEFAULT_MASK_HEIGHT = 45;
export const DEFAULT_MASK_SCALE = 100;

// Container dimensions
export const DEFAULT_CONTAINER_WIDTH = 400;
export const DEFAULT_CONTAINER_HEIGHT = 400;

// UI constants
export const OPACITY_TRANSITION_DURATION = 120; // milliseconds
